import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check, X } from 'lucide-react';
export function TargetSection() {
  return <section className="py-24 px-6 bg-[#0a0a0a]" data-id="element-96">
      <div className="max-w-6xl mx-auto" data-id="element-97">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-98">
          {/* YES Column */}
          <FadeIn direction="right" className="space-y-8" data-id="element-99">
            <h3 className="text-2xl font-black text-white mb-8 border-b-2 border-green-500/50 pb-4 inline-block" data-id="element-100">
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-6" data-id="element-101">
              {['Trabajas, estás cansado, y aun así quieres subir ingresos', 'Te hartaste de empezar y abandonar', 'Quieres un sistema claro, sin espiritualidad ni humo', 'Estás dispuesto a hacer 45–60 minutos al día (la mayoría de días)'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-102">
                  <Check className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-103" />
                  <span className="text-lg text-gray-300" data-id="element-104">{item}</span>
                </li>)}
            </ul>
          </FadeIn>

          {/* NO Column */}
          <FadeIn direction="left" delay={0.2} className="space-y-8" data-id="element-105">
            <h3 className="text-2xl font-black text-white mb-8 border-b-2 border-red-500/50 pb-4 inline-block" data-id="element-106">
              NO ES PARA TI SI:
            </h3>
            <ul className="space-y-6" data-id="element-107">
              {['Buscas “manifestar” sin ejecutar', 'Quieres un cambio sin límites con el teléfono', 'Quieres que alguien te cargue en brazos'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-108">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-109" />
                  <span className="text-lg text-gray-300" data-id="element-110">{item}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}